{
	"ariaAiStylesList": "AI Styles List",
	"ariaViewCategory": "View AI Style Category {{name}}",
	"brandAiStyles": "{{brand}} AI Styles",
	"categoryAll": "All",
	"categoryAnalogInspired": "Analog-Inspired",
	"categoryFeatured": "Featured",
	"categoryMoodyWarm": "Moody & Warm",
	"categoryNaturalColor": "Natural Color",
	"categoryStyledTones": "Styled Tones",
	"internal": "Internal",
	"loadingDetails": "Loading style details...",
	"myAiStyles": "My AI Styles"
}
